module.exports = __webpack_public_path__ + "img/pokebowl.b6f07592.png";